<template>
    <modal-overlay
        instance-class="product-consent-management"
        :id="id"
    >
        <div class="modal-overlay__content__item">
            <h1 class="heading1 custom-color-f">
                Wir benötigen Ihre Zustimmung
            </h1>
            <p>
                Wenn Sie uns Ihre Zustimmung geben, messen wir die Anzahl der Seitenaufrufe. Dies ermöglicht es uns zu erkennen, wie viele Personen unsere Webseite aufrufen. Für diese Analyse nutzen wir Google Analytics 4 mit der Standardmessung, alles andere ist deaktiviert. Die Nutzung der Daten zu eigenen Zwecken haben wir Google untersagt. Ihre IP-Adresse wird umgehend gelöscht.
            </p>
            <p>
                Mit Ihrer Zustimmung laden wir auch ein LiveChat-Widget, worüber Sie mit den Experten von „Frag die Apotheke“ chatten können. Dabei werden technische Daten wie insb. die IP-Adresse weitergegeben und Cookies verwendet. Für Ihre Nutzung des Chats gelten die <a href="https://frag-die-apotheke.de/datenschutz"  class="custom-color-b" target="_blank" rel="noopener noreferrer nofollow"> Datenschutzhinweise von „Frag die Apotheke“</a>.
            </p>
            <p>
                Mit dem Klick auf „Zustimmen“ stimmen Sie der Verarbeitung der auf Ihrem Gerät bzw. Ihrer Endeinrichtung gespeicherten Daten wie z.B. persönlichen Identifikatoren oder IP-Adressen für die Verarbeitungszwecke gem. § 25 Abs. 1 TDDDG sowie Art. 6 Abs. 1 lit. a DSGVO zu.
            </p>
            <p>
                Sie können Ihre Einwilligungserklärung auch detailliert anpassen. In unserer <a href="/Datenschutz" class="custom-color-b" target="_blank" rel="noopener noreferrer nofollow">Datenschutzerklärung</a> finden Sie weitere Informationen zu diesen Datenverarbeitungen sowie zum Widerruf Ihrer Einwilligung(en).
            </p>
            <div class="consent-line">
                Websiteanalyse
                <label class="toggle-switch">
                    <input type="checkbox" v-model="gaConsent">
                    <span class="slider"></span>
                  </label>
            </div>
            <div class="consent-line">
                Externe Inhalte („Frag die Apotheke“)
                <label class="toggle-switch">
                    <input type="checkbox" v-model="fdaConsent">
                    <span class="slider"></span>
                  </label>
            </div>
            <div class="button-container">
                <button
                    class="button button--invert custom-color-b custom-border-color-b"
                    @click="dissent"
                >
                    Ablehnen
                </button>
                <button
                    class="button button--invert custom-color-b custom-border-color-b"
                    @click="save"
                >
                    Auswahl speichern
                </button>
                <button
                    class="button button--invert custom-color-b custom-border-color-b"
                    @click="consent"
                >
                    Zustimmen
                </button>
            </div>
            <div class="consent-imprint custom-border-color-b">
                <a href="/Impressum" target="_blank" rel="noopener noreferrer nofollow" class="custom-color-b">Impressum</a>
            </div>
        </div>
    </modal-overlay>
</template>

<script>
import ModalOverlay from '../modalOverlay/modalOverlay.vue';
import { setTrackingCookie, hasUserTrackingConsentGiven } from '../../services/trackingService.js';
import { setFdACookie, hasUserFdAConsentGiven } from '../../services/consentService.js';

export default {
    name: 'ProductConsentManagement',
    components: { ModalOverlay },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            // set initial value to "false", if Consent not given/set (null is falsy)
            gaConsent: hasUserTrackingConsentGiven() || false,
            fdaConsent: hasUserFdAConsentGiven() || false
        };
    },
    methods: {
        storeDecision(trackingValue, fdaValue,  event){
            ModalOverlay.methods.closeModalClick.call(this, event);
            setTrackingCookie(trackingValue);
            setFdACookie(fdaValue);
        },
        save(event) {
            this.storeDecision(this.gaConsent, this.fdaConsent, event);
        },
        consent(event) {
            this.storeDecision(true, true, event);
            this.gaConsent = true;
            this.fdaConsent = true;
        },
        dissent(event) {
            this.storeDecision(false, false, event);
            this.gaConsent = false;
            this.fdaConsent = false;
        }
    }
};
</script>

<style lang="scss">
.product-consent-management {
    .modal-overlay__content__item {
        padding: 16px 24px;
        flex-direction: column;

        h1 {
            font-size: 1.6rem;
        }

        @media #{$tablet} {
            max-width: 70ch;
        }

        a {
            font-weight: 400;
        }
    }

    .button-container {
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
    }

    .button {
        @media (max-width: 572px){
            padding: 10px 5px;
            box-shadow: 1px 1px 0 #757575;
        }
    }

    p {
        margin-bottom: 5px;
    }
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

/* Versteckt die Standard-Checkbox */
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Der sichtbare Hintergrund des Schalters */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

/* Der bewegliche Kreis */
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 1px;
  bottom: 1px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

/* Ändert die Farbe und Position, wenn die Checkbox aktiviert ist */
input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.consent-line {
  margin: 4px;

  label {
    float: right;
  }
}

.consent-imprint {
    margin-top: 20px;
    border-top: 1px;
    border-style: solid;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    padding-top: 5px;
}
</style>